import { TableCard } from '../../../../components'
import { PersonalAtendimentosListHeader } from './components/header/PersonalAtendimentosListHeader'
import { PersonalAtendimentosResumo } from './components/PersonalAtendimentosResumo'
import { ListFiltersProvider } from './core/ListFiltersProvider'
import { QueryRequestProvider } from './core/QueryRequestProvider'
import { QueryResponseProvider } from './core/QueryResponseProvider'
import { PersonalAtendimentosTable } from './table/PersonalAtendimentosTable'

const PersonalAtendimentosList = () => {
  return (
    <>
      <PersonalAtendimentosResumo />
      <TableCard>
        <PersonalAtendimentosListHeader />
        <PersonalAtendimentosTable />
      </TableCard>
    </>
  )
}

export const PersonalAtendimentosListWrapper = () => (
  <QueryRequestProvider>
    <QueryResponseProvider>
      <ListFiltersProvider>
        <PersonalAtendimentosList />
      </ListFiltersProvider>
    </QueryResponseProvider>
  </QueryRequestProvider>
)
